<template>
  <div class="panel" :style="style">
    <slot/>
  </div>
</template>

<script>
export default {
    name: 'Panel',
    props: {
      width: {
        type: String
      }
    },
    computed: {
      style: function() {
        return `width: ${this.width}px`
      }
    }
}
</script>

<style scoped>

.panel {
  background-color: #64dfdf;
  color: white;
  padding: 10px;
  border-radius: 10px;
  height: calc(100% - 20px);

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

</style>


// WEBPACK FOOTER //
// src/components/Panel.vue